<template>
  <div
    :class="activeStyle"
    class="review-type-card pa-5 rounded"
    @click="$emit('click')"
  >
    <v-row
      class="subtitle-2 font-weight-bold grey--text text--darken-4 px-1"
    >
      {{ reviewTitle }}
    </v-row>
    <v-row class="body-2 px-1 py-2">
      {{ description }}
    </v-row>
    <v-row
      class="subtitle-2 font-weight-bold grey--text text--darken-2 px-1"
    >
      <div class="d-flex align-center mr-3">
        <v-icon color="primary" left class="material-icons-outlined">
          date_range
        </v-icon>
        {{ timeframe }}
      </div>
      <div class="d-flex align-center">
        <v-icon color="primary" left class="material-icons-outlined">
          person
        </v-icon>
        {{ numReviewers }}
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ReviewTypeCard',
  props: {
    reviewTitle: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    timeframe: {
      type: String,
      default: null,
    },
    numReviewers: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    activeStyle() {
      return this.selected ? 'active' : 'inactive';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.review-type-card {
  cursor: pointer;
  user-select: none;
}
.active {
  border: 2px solid;
  border-color: var(--v-primary-base);
  background-color: #f5f8fe;
}
.inactive {
  border: 1px solid;
  border-color: map-get($grey, 'lighten-1');
  background-color: map-get($grey, 'lighten-5');
}
</style>
